import { Container, Modal } from "react-bootstrap";
import PrimaryButton from "../../../util/Btns/PrimaryButton";

import styles from "./ComingSoonModal.module.scss";
import clock from "../../../Assets/comingSoonClock.svg";

const ComingSoonModal = ({ showComingSoon, setShowComingSoon }) => {
  const handleClose = () => {
    setShowComingSoon(false)
  };

  return (
    <>
      <Container>
        <Modal
          show={showComingSoon}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Body>
            <div className={styles.body}>
              <img src={clock} alt="logo" className="mr-1 fluid logo" />
              <h3>This Feature is Coming Soon!</h3>
              <h4>
                This feature is not available yet but soon it will be available
                for the users.
              </h4>
              <PrimaryButton onClick={() => setShowComingSoon(false)}>
                Ok
              </PrimaryButton>
              {/* </div> */}
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default ComingSoonModal;
